
import { Component, OnInit } from '@angular/core';
import { Subcliente } from '../subcliente.model';
import { BackendService } from '../../core/backend.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../../core/api.service';
import { Parametric } from '../../productos/parametric.model';
import { DialogService } from '../../shared-components/modals/dialog.service';
import { SnackService } from '../../shared-services/snack.service';
import { SubclienteMontoMasivo } from '../subclienteMontoMasivo.model';



@Component({
  selector: 'app-cliente-user-monto-max-masivo',
  templateUrl: './cliente-user-monto-max-masivo.component.html',
  styleUrls: ['./cliente-user-monto-max-masivo.component.scss']
})
export class ClienteUserMontoMaxMasivoComponent implements OnInit {

  cliente: any;
  subclientes: Subcliente[] = [];
  operacionSeleccionada: string = 'mensual';
  tipoLimites: Parametric[];

  subclienteMontoMasivo: SubclienteMontoMasivo = new SubclienteMontoMasivo();

  isLoading = false;
  totalItems: number;

  constructor(
    private backendService: BackendService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private snackService: SnackService,
    private apiService: ApiService,
    private dialogService: DialogService,
  ) { }

  async ngOnInit() {
    await this.cargarCliente();
    await this.getTiposLimiteMontoCompra();
  }

  async cargarCliente() {
    this.activatedRoute.data.subscribe(data => {
      this.cliente = data.cliente;
    })
  }

  async getTiposLimiteMontoCompra() {
    this.tipoLimites = await this.apiService.get(Parametric, Parametric.path + 'tipos_limite_montos_compra/', null).toPromise();
  }

  back() {
    this.router.navigate(['/clientes/detalles/' + this.cliente.id]);
  }

  confirmSave() {
    this.dialogService.confirm(
      '¿Está seguro que desea guardar los cambios?')
      .then(res => {
        if (res) {
          this.saveSubclientes(res);
        }
      });
  }

   saveSubclientes(res) {
        
    this.subclienteMontoMasivo.idClientePadre = this.cliente.id;

    if (res) {

      this.snackService.spinner(true);

      try {

        this.backendService.update(SubclienteMontoMasivo.path + 'save-monto-max-masivo', this.subclienteMontoMasivo);
        console.log("Se hizo el put");
        this.router.navigate(['/clientes/detalles/' + this.cliente.id]);
        this.snackService.success('Usuarios editados satisfactoriamente');

      } catch (ex) {
        if (ex[0]) {
          this.snackService.error(ex[0].details);
        } else if (ex.errors) {
          this.snackService.error(ex.errors[0].defaultMessage);
        } else {
          this.snackService.error(ex.message);
        }
      } finally {
        this.snackService.spinner(false);
      }
    }
  }

  getChecked(event: any) {
    this.subclienteMontoMasivo.idTipoMontoMaximoMasivo = event.value;
  }

  onPageChange(page: any) {
    // TODO: Paginar
  }
}



// WEBPACK FOOTER //
// ./src/app/cliente/cliente-user-monto-max-masivo/cliente-user-monto-max-masivo.component.ts